import React, { Component } from "react";
import axios from "axios";

import NewsletterSignupForm from "./NewsletterSignupForm";
import Inner from "./Inner";

export default class Newsletter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      invalidEmailForm: false,
      signUpSuccess: false,
      consent: {
        id: null,
        text: `Vi bruger kun dine oplysninger til udsendelse af nyhedsbrevet, og
      sletter dem, hvis du framelder dig, eller hvis vi ophører med at
      udsende nyheder. Læs mere om, hvordan vi behandler dine oplysninger
      <a class="kammer-link" href="http://kammeradvokaten.dk/om-os/saadan-haandterer-vi-dine-personoplysninger/" target="_blank">her</a>.`,
      },
      subscriptionIds: [],
    };
  }

  componentDidMount = () => {
    var self = this;
    axios
      .get("/ajax/newsletter/getconsent")
      .then((response) => {
        if (response.data) {
          self.setState({ consent: response.data });
        }
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get("/ajax/newsletter/getnewsletters")
      .then((response) => {
        if (response.data) {
          const ids = response.data.map((x) => x.id);
          self.setState({ subscriptionIds: ids });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  onSignupEmailSuccess = () => {
    this.setState({ signUpSuccess: true });
  };

  onInvalidEmailForm = () => {
    this.setState({ invalidEmailForm: true });
  };

  onValidEmailForm = () => {
    this.setState({ invalidEmailForm: false });
  };

  render() {
    const { signUpSuccess, invalidEmailForm, consent, subscriptionIds } =
      this.state;
    return (
      <Inner>
        <div className="newsletter">
          <h2>Tilmelding til nyhedsbrev</h2>
          <p>
            Bliv opdateret med seneste nyt om udbudsret og få information om
            vores aktiviteter og invitationer til faglige arrangementer.
          </p>
          <p dangerouslySetInnerHTML={{ __html: consent.text }}></p>
          {subscriptionIds.length > 0 && consent.id != null && (
            <NewsletterSignupForm
              onSignUpSuccess={this.onSignupEmailSuccess}
              onValidForm={this.onValidEmailForm}
              onInvalidForm={this.onInvalidEmailForm}
              subscriptionIds={subscriptionIds}
              consentId={consent.id}
              formName="newsletter-block"
            />
          )}
          {invalidEmailForm && (
            <div className="message error">
              Der var en fejl i dit navn eller e-mail.
            </div>
          )}
          {signUpSuccess && (
            <div className="message success">Tak for din tilmelding.</div>
          )}
        </div>
      </Inner>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Newsletter.js